import { Quote } from 'lucide-react';
import type { QuoteBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const quoteConfig: BlockTypeConfig<QuoteBlock> = {
  type: 'quote',
  label: 'Quote',
  description: 'Testimonial or pull quote with optional author',
  icon: Quote,
  category: 'data',
  createDefault: () => ({
    text: '',
    style: 'simple',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.style',
      label: 'Style',
      options: [
        { value: 'simple', label: 'Simple' },
        { value: 'card', label: 'Card' },
        { value: 'large', label: 'Large' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  variants: [
    {
      id: 'default',
      label: 'Simple',
      thumbnail: '/admin/page-editor/variants/quote-default.svg',
      apply: (d) => ({ ...d, variant: 'default', style: 'simple' }),
    },
    {
      id: 'magazine-pullquote',
      label: 'Magazine pullquote',
      thumbnail: '/admin/page-editor/variants/quote-magazine-pullquote.svg',
      apply: (d) => ({ ...d, variant: 'magazine-pullquote', style: 'large' }),
    },
    {
      id: 'card',
      label: 'Card',
      thumbnail: '/admin/page-editor/variants/quote-card.svg',
      apply: (d) => ({ ...d, variant: 'card', style: 'card' }),
    },
  ],
  sheet: [
    { kind: 'text', path: 'data.author', label: 'Author' },
    { kind: 'text', path: 'data.role', label: 'Role' },
    { kind: 'media', path: 'data.imageUrl', label: 'Author photo', assetType: 'image' },
  ],
};
